import React from 'react';
import './Slider.css';
import Countdown from 'react-countdown';

function Slider({ minutes, seconds, percentage }) {
  let formattedPercentage = percentage / 3;

  // alert(minutes);

  return (
    <>
      <div className="slider">
        <div
          className="slider-animation"
          style={{ transform: `translateX(-${formattedPercentage}%)` }}
        ></div>
      </div>
      <div className="timer-remaining">
        <div
          style={{
            fontSize: '1.5rem',
            fontFamily: 'Karla',
          }}
        >
          {Math.round(100 - formattedPercentage)}% of your break has elapsed.{' '}
        </div>
        <div style={{ marginTop: '1rem', fontSize: '1.05rem' }}>
          {minutes} min and {seconds} second(s) remaining
        </div>
      </div>
    </>
  );
}

export default Slider;
